import axios from 'axios';
import { store } from 'Store/store.index';
import { HttpRequest } from './request.utils'
import {baseUrlApis} from 'Api/index';
import { URL_PLATFORM, PHANTOMONLINE_GLOBAL_CONFIG, URL_ESIGNCN, URL_ACCOUNT } from 'Api/constants';

export default class ESignChinaApi extends HttpRequest{
    constructor() {
        super();
        this.init();
    }
    init = () => {
        // axios.defaults.timeout = 5000
        try {
            baseUrlApis.getBaseUrlBy(URL_ESIGNCN).then((url)=>{
                this.URL_ESIGNCN = url;
                const axiosClient = axios.create({
                    // baseURL: `${this.CPDFURI}/sign/`,
                    baseURL: `${url}/api`,
                    timeout: 5000
                });
                super.initialize(axiosClient, () => {
                    let responseCfg = {
                        success: (res) => {
                            if (+res.data.code === 0 || +res.data.ret === 0) {
                                return res.data.data;
                            } else {
                                return res.data;
                            }
                        },
                        error: (error) => {
                            return Promise.reject(error);
                        },
                    }

                    let requestConfig = {
                        success: (req) => {
                            // req.headers['access-token'] = store.userStore.token
                            // req.headers['supplier-id'] = 1
                            return req
                        },
                        error: (error) => {
                            return Promise.reject(error);
                        },
                    }
                    this.interceptorsProxyFn(requestConfig, responseCfg);
                });
            })

        } catch(err){
            throw(err)
        }
        try {
            baseUrlApis.getBaseUrlBy(URL_PLATFORM).then((data) => {
                this.CPDFURI = data;

            });
        } catch (error) {
            throw error;
        }
    };
    getURL_ESIGNCN() {
        return this.URL_ESIGNCN;
    }
    getAccountSubscription({
        wardType = 0,
        tenantId
    }) {
        const params = {
            accessToken: store.userStore.token,
            tenantId,
            wardType
        }
        return this.get({
            url: `/account/subscription`,
            data: {},
            config: {
                params
            }
        })
    }
    innerSealCreate({
        signerId,
        pictureBase64,
        pictureType = 'png'
    }) {
        const params = {
            accessToken: store.userStore.token,
            enterpriseId: store.userStore.roleInfo?.enterpriseId
        }
        return this.post({
            url: `/inner/seal/create`,
            data: {
                signerId,
                pictureBase64,
                pictureType
            },
            config: {
                params
            }
        });
    }
    getInnerSealList() {
        const params = {
            accessToken: store.userStore.token,
            enterpriseId: store.userStore.roleInfo?.enterpriseId
        }
        return this.get({
            url: `/inner/seal/list`,
            data: {},
            config: {
                params,
                timeout: 1000*60*60
            }
        });
    }
    innerSealDisable({ sealId }) {
        const params = {
            accessToken: store.userStore.token,
            enterpriseId: store.userStore.roleInfo?.enterpriseId
        }
        return this.post({
            url: `/inner/seal/disable`,
            data: {
                sealId
            },
            config: {
                params
            }
        });
    }
    getUserSignLog({
        wardType,
        page,
        pageSize,
        from = 0,
        sortBy = 'desc'
    }) {
        // wardType 0: 对外 1： 对内
        const params = {
            accessToken: store.userStore.token,
            enterpriseId: store.userStore.roleInfo?.enterpriseId,
            wardType,
            page,
            pageSize,
            from,
            sortBy
        }
        return this.get({
            url: `/user/sign-log`,
            data: {},
            config: {
                params
            }
        })
    }
    getUserSubscription({
        wardType = 0
    }) {
        const params = {
            accessToken: store.userStore.token,
            tenantId: store.userStore.roleInfo?.enterpriseId,
            wardType
        }
        return this.get({
            url: `/user/subscription`,
            data: {},
            config: {
                params,
                timeout: 20000
            }
        });
    }
    getRecordSubscription({
        wardType = 0
    }) {
        const params = {
            accessToken: store.userStore.token,
            tenantId: store.userStore.roleInfo?.enterpriseId,
            wardType
        }
        return this.get({
            url: `/user/new-subscription`,
            data: {},
            config: {
                params
            }
        });
    }
    getJwtToken(enterpriseId) {
        const URI = window[PHANTOMONLINE_GLOBAL_CONFIG][URL_ACCOUNT];
        return this.get({
            url: `${URI}/api/users/jwt-by-token`,
            config: {
                params: {
                    accessToken: store.userStore.token,
                    enterpriseId,
                    pluginName: 'esignCN'
                }
            }
        });
    }
    checkJwtToken(jwt, bIgnoreTime = true) {
        const URI = window[PHANTOMONLINE_GLOBAL_CONFIG][URL_ACCOUNT];
        return this.get({
            url: `${URI}/api/users/check-jwt?JWT=${jwt}&bIgnoreTime=${bIgnoreTime}`,
        });
    }
    getSAMLResponse() {
        let CASURI = window[PHANTOMONLINE_GLOBAL_CONFIG].casApiUrl;
        return this.get({
            url: `${CASURI}/cas/saml/assertion?access_token=${store.userStore.token}`,
            data: {},
            config: {
                accessToken: store.userStore.token
            }
        });
    }
    ValidateSAMLResponse({ SAML }) {
        // https://account-azk8s.foxitcloud.com/cas/saml/checkAssertion?enterpriseId=61a9af314d225c0001f86f41&bIgnoreTime=false
        let CASURI = window[PHANTOMONLINE_GLOBAL_CONFIG].casApiUrl;

        return this.post({
            url: `${CASURI}/cas/saml/checkAssertion?bIgnoreTime=true`,
            data: SAML,
            config:{
                transformRequest: [
                    function (data) {
                        return data
                    }
                ],
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        });
    }
    ValidateSAMLResponseAllInfo(param){
        let CASURI = window[PHANTOMONLINE_GLOBAL_CONFIG].casApiUrl;
        return this.post({
            url: `${CASURI}/cas/saml/checkAssertionAllInfo`,
            data: param,
            // config:{
            //     transformRequest: [
            //         function (data) {
            //             return data
            //         }
            //     ],
            //     headers: {
            //         'Content-Type': 'application/json'
            //     }
            // }
        });
    }

    // ------------------ underline is outer api -----------
    // *** SaaS版API *** //
    // 获取全局配置
    getESignConfig() {
        const params = {}
        return this.get({
            url: `/site/config`,
            config: {
                params
            }
        })
    }

    // 获取实名认证URL
    getAuthUrl_V2(data) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1
        }
        return  this.post({
            url: `/real-auth/auth-url`,
            data,
            config: {
                params
            }
        })
    }

    // 获取意愿认证URL
    createWillingnessAuth_V2(data) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1
        }
        return this.post({
            url: `/will-auth/create-auth`,
            data: data,
            config: {
                params,
                timeout: 1000*60*60
            }
        })
    }

    // 查询eSign用户绑定信息
    getESignAccountInfo_V2(tenantId) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1 // 供应商id,易签宝默认为1
        }
        if (tenantId) {
            params.tenantId = tenantId;
        }
        return this.get({
            url: `/account/binding`,
            config: {
                params
            }
        });
    }

    // 查询实名认证结果
    getOAuthResult_V2({ email, mobile, orgName }) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1
        }
        if (orgName) {
            params.name = orgName;
            return this.get({
                url: `/authorizer/org-info`,
                config: {
                    params
                }
            });
        } else {
            if (email) {
                params.email = email;
            }
            if (mobile) {
                params.mobile = mobile;
            }
            return this.get({
                url: `/authorizer/person-info`,
                config: {
                    params
                }
            });
        }
    }

    // 查询意愿认证结果
    getWillAuthResult_V2({bizId, bizType}) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1,
            bizId,
            bizType
        }
        return this.get({
            url: `/will-auth/query-result`,
            config: {
                params,
                timeout: 20000
            }
        });
    }

    // 绑定个人用户
    bindESignPersonAccount_V2(data) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1
        }
        return this.post({
            url: `/account/person-bind`,
            data,
            config: {
                params
            }
        });
    }

    // 绑定企业用户
    bindESignOrgAccount_V2(data) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1
        }
        return this.post({
            url: `/account/org-bind`,
            data,
            config: {
                params
            }
        });
    }

    // 获取个人印章列表
    getPersonTemplateSeal_V2({ accountId}) {
        let params = {
            accountId,
            accessToken: store.userStore.token,
            supplierId: 1,
            pageNum: 1,
            pageSize: 20
        }
        return this.get({
            url: `/seal/person-seals`,
            config: {
                params,
                timeout: 1000*60*60
            }
        });
    }

    // 获取企业印章列表
    getOrgTemplateSeal_V3({ orgId, accountId, enterpriseId }) {
        let params = {
            accountId,
            orgId,
            enterpriseId,
            accessToken: store.userStore.token,
            supplierId: 1,
            pageNum: 1,
            pageSize: 20
        }
        return this.get({
            url: `/seal/new-org-seals`,
            config: {
                params,
                timeout: 1000*60*60
            }
        })
    }

    // 签名接口
    signFileDigest_V2({hash, operatorId, signerId, willingnessBizId,chapterType,tenantId,docId,from, signId, processId, recipientOrder, chargeFlag}) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: willingnessBizId ? 1 : 2,
            signId
        }
        return this.post({
            url: `/signature/pdf-hash`,
            data: {
                hash,
                operatorId,
                signerId,
                willingnessBizId,
                chapterType,
                tenantId,
                docId,
                from,
                processId,
                recipientOrder,
                chargeFlag
            },
            config: {
                params,
                timeout: 1000*60*60
            }
        })
    }

    signatureFileDigestInner({ signId, hash, processId, from = 0, recipientOrder, signerId }) {
        const enterpriseId = store.userStore.roleInfo.enterpriseId;
        const params = {
            accessToken: store.userStore.token,
            enterpriseId,
            signId,
        }
        return this.post({
            url: `/inner/signature/pdf-hash`,
            data: {
                hash,
                from,
                signerId,
                processId,
                recipientOrder
            },
            config: {
                params,
                timeout: 1000*60*60
            }
        })
    }

    // 获取当前账户所属租户信息
    // 获取当前账户的过期时间和剩余份数
    // wardType 1:对内；0：对外
    getSubscription( { tenantId, wardType } ) {
        const params = {
            accessToken: store.userStore.token,
            tenantId: tenantId ? tenantId: '',
            wardType: wardType ? wardType : 0
        }
        return this.get({
            url: `/user/subscription`,
            config: {
                params,
                timeout: 1000*60*60
            }
        })
    }
    getNewSubscription( { tenantId } ) {
        const params = {
            accessToken: store.userStore.token,
        }
        if(tenantId){
            params.tenantId = tenantId
        }
        return this.get({
            url: `/user/new-subscription`,
            config: {
                params,
                timeout: 1000*60*60
            }
        })
    }

    // 获取个人章创建url
    getPersonCreateUrl(accountId) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1,
            accountId,
            redirectUrl: 'iframe://close',
            sealCreateMode: 'template',
            sealTemplateStyle: 'RECTANGLE_BORDER'
        }
        return this.get({
            url: `/seal/psn-create-url`,
            config: {
                params,
                timeout: 1000*60*60
            }
        });
    }
    // 获取个人章管理url
    getPersonAdminUrl(accountId) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1,
            accountId,
            hidePageButton: '[]',
            // hidePageButton: ["SET_DEFAULT","RENAME","DELETE"]
        }
        return this.get({
            url: `/seal/person-admin-url`,
            config: {
                params,
                timeout: 1000*60*60
            }
        });
    }

    // 获取企业章管理url
    getOrgAdminUrl(orgId) {
        const params = {
            accessToken: store.userStore.token,
            supplierId: 1,
            orgId,
        }
        return this.get({
            url: `/seal/org-admin-url`,
            config: {
                params,
                timeout: 1000*60*60
            }
        })
    }


    // 创建签单流程
    createSignProcess({ title,wardType, saveType,creatorName, creatorPhone, creatorEmail, recipients }) {
        const data = {
            "name": title,
            "ward_type": wardType,
            "doc_store": saveType,
            "creator_name": creatorName,
            "creator_phone": creatorPhone,
            "creator_email": creatorEmail,
            "recipients": recipients
        }
        const params = {
            accessToken: store.userStore.token,
        }
        return this.post({
            url: `/sign-process/create`,
            data,
            config: {
                params,
                timeout: 1000*60*60
            }
        });
    }

    // 上传文档
    uploadSignedFile({ fileName, blob, processId, recipientOrder }) {
        const forms = new FormData();
        forms.append('processId', processId);
        forms.append('recipientOrder', recipientOrder);
        forms.append('accessToken', store.userStore.token);
        forms.append('file', blob, fileName);

        return this.post({
            url: '/file/upload',
            data: forms,
            config: {
                timeout: 1000 * 60 * 60
            }
        });
    }

    // 获取签名流程信息
    getSignFlowInfo({ processId }) {
        const params = {
            accessToken: store.userStore.token,
            processId
        }
        return this.get({
            url: `/sign-process/info`,
            data: {},
            config: {
                params
            }
        });
    }

    // 删除签名流程
    deleteFlow({processId}) {
        return this.post({
            url: `/sign-process/delete`,
            config: {
                params: {
                    accessToken: store.userStore.token
                }
            },
            data: {
                processId
            }
        })
    }

    // 撤销签名流程
    cancelFlow({processId, comment}) {
        return this.post({
            url: `/sign-process/cancel`,
            config: {
                params: {
                    accessToken: store.userStore.token,

                },
                timeout: 20000
            },
            data: {
                processId,
                comment
            }
        })
    }

    // 查询签署记录复合接口
    getSignProcessList({processId,role,wardType,name,status, perPage, currentPage,errCallback}) {

        if (!currentPage) {
            currentPage = 1;
        }
        let params = {
            accessToken: store.userStore.token,
            needTotal:1,
            pageSize:perPage,
            page:currentPage,
        }
        if(processId) params.processId = processId;
        if(role !== undefined) params.role = role;
        if(wardType) params.wardType = wardType;
        if(name) params.name = name;
        if(status) params.status = status;

        return this.get({
            url: `/sign-process/list`,
            data: {},
            config: {
                params,
                timeout: 20000
            },
            errCallback
        });
    }
    // 查询签署记录总数计算
    getSignProcessListTotal() {

        let params = {
            accessToken: store.userStore.token,
        }
        return this.get({
            url: `/sign-process/list-total`,
            data: {},
            config: {
                params,
                timeout: 20000
            }
        });
    }
    // 签署提醒接口
    noticeSign(processId) {
        const data = {
            processId
        }
        const params = {
            accessToken: store.userStore.token,
        }
        return this.post({
            url: `/notice/message`,
            data,
            config: {
                params
            }
        });
    }

    // 离线文档 签署完成确认
    esignConfirm({ processId, recipientOrder}) {
        const params = {
            accessToken: store.userStore.token,
        }
        const forms = new FormData();
        forms.append('processId', processId);
        forms.append('recipientOrder', recipientOrder);

        return this.post({
            url: `/sign-process/confirm`,
            data: forms,
            config: {
                params,
                timeout: 1000*60*60
            }
        });
    }

    // 查询流程签中自己的历史联系人
    // type: name, contcat, company
    searchFlowMan({type, keyword, page= 1, pageSize= 50}) {
        const params = {
            accessToken: store.userStore.token,
            query: keyword,
            type,
            page,
            pageSize
        }
        return this.get({
            url: `/user/search-recipient`,
            data: {},
            config: {
                params
            }
        }).then(res => {
            if (res.code) {
                return null;
            } else {
                return res;
            }
        }) ;
    }


    // GET /user/enterprise-user
    getEnterpriseUser(enterpriseId) {
        const params = {
            accessToken: store.userStore.token,
            enterpriseId
        }
        return this.get({
            url: `/user/enterprise-user`,
            data: {},
            config: {
                params
            }
        });
    }
    getUserRole(enterpriseId) {
        const params = {
            accessToken: store.userStore.token,
            enterpriseId
        }
        return this.get({
            url: `/user/enterprise-sso-and-role`,
            data: {},
            config: {
                params
            }
        });
    }

    // 接口文档 https://confluence.foxitsoftware.com/pages/viewpage.action?pageId=172992790
    addEvidenceForSign({ signId, operatorFlowId, signerFlowId, signLogId, oriHash, signedHash, willAuthId }) {
        return this.post({
            url: "/evidence/add-evidence",
            data: { operatorFlowId, signerFlowId, signLogId, oriHash, signedHash, willAuthId },
            config: {
                params: {
                    accessToken: store.userStore.token,
                    supplierId: 1,
                    signId
                }
            }
        }).then(res => {
            if (res.code && res.code !== 0) {
                return Promise.reject('add_evidence_error')
            } else {
                return Promise.resolve()
            }
        })
    }

    getEvidenceList(signIds) {
        return this.get({
            url: "/evidence/lists",
            config: {
                params: {
                    signId: signIds
                },
                // onDownloadProgress: progressEvent => {
                //     if (progressEvent.lengthComputable) {
                //         callback && callback(progressEvent)
                //     }
                // }
            }
        })
    }
    getEsignCNLicence(product = 'internal'){
        // const url =  baseUrlApis.getCwsBaseUrlByBaseUrl();
        // const params = {
        //     "access-token": store.userStore.token,
        //     "enterpriseId":store.userStore.roleInfo?.enterpriseId,
        //     product
        // }
        // return this.get({
        //     url: `${url}cpdfapi/v1/esign-cn/auth`,
        //     data: {},
        //     config: {
        //         params
        //     }
        // });

        if( product !== 'internal') {
            product = 'external';
        }

        const params = {
            accessToken: store.userStore.token,
            enterpriseId: store.userStore.roleInfo?.enterpriseId,
            product
        }
        return this.get({
            url: `/user/enterprise-auth`,
            data: {},
            config: {
                params
            }
        });
    }
    searchEmailForSign(params) {
        const _params = {
            ...params,
            enterpriseId: store.userStore.roleInfo?.enterpriseId,
            // userId: store.userStore.userInfo?.cUserID,
            "access-token": store.userStore.token
        };
        // let url = 'https://pheecws-devazk8s.connectedpdf.com';
        const url =  baseUrlApis.getCwsBaseUrlByBaseUrl();
        return this.get({
            url: `${url}cpdfapi/v1/enterprise/user`,
            data: {},
            config: {
                params: _params
            }
        });
    }
    applyOutStampUsePermission({ orgId, accountId, sealId, sealName, applicantName}) {
        return this.post({
            url: `/seal/org-internal-auth`,
            config: {
                params: {
                    accessToken: store.userStore.token,
                    supplierId: 1
                },
                timeout: 1000*60*60
            },
            data: {
                orgId,
                accountId,
                sealId,
                sealName,
                applicantName
            }
        })
    }
    resendApplyOutStampUsePermission({ orgId, accountId, sealId}) {
        return this.post({
            url: `/seal/resend`,
            config: {
                params: {
                    accessToken: store.userStore.token,
                    supplierId: 1
                },
                timeout: 1000*60*60
            },
            data: {
                orgId,
                accountId,
                sealId,
            }
        })
    }
}

